import { useTranslation } from "react-i18next";

import styles from "./PaymentStatusCard.module.scss";
import { formatCurrency } from "../../utils/currency";
import classNames from "classnames";
import { Icon, IconType } from "../Icon";
import { Icons } from "../../utils";
import { BillingPaymentsPayment } from "../../types/billing";
import { calculateDisplayPaymentStatus } from "../../utils/billing";
import { BILLING_PAYMENT_STATUS_PAID_STATUSES } from "../../constants/billing";

type BillingStatusSummaryCardProps = {
  payments: BillingPaymentsPayment[];
  amount: number;
};

export const BillingStatusSummaryCard: React.FC<BillingStatusSummaryCardProps> = ({
  payments,
  amount,
}) => {
  const { t } = useTranslation();
  const status = calculateDisplayPaymentStatus(payments);
  const isPaidStatus = BILLING_PAYMENT_STATUS_PAID_STATUSES.includes(status);
  const hasAmount = amount > 0;

  return (
    <div
      className={classNames(styles.container, styles[status], { [styles.noAmount]: !hasAmount })}
    >
      <div className={classNames(styles.statusCircle, styles[status])}>
        <Icon name={isPaidStatus ? Icons.check : Icons.exclamationMark} type={IconType.white} />
      </div>
      <p>{t(`billing.billingStatusSummaryCard.${status}`)}</p>
      {hasAmount && <p className={styles.amount}>{formatCurrency(amount)}</p>}
    </div>
  );
};
